// src/constants/nationalities.js
/**
 * 국적 셀렉트용 국가 리스트 (ISO 3166-1 alpha-2 기준)
 * label: "한국어 (English)" 형식
 */
export const NATIONALITY_OPTIONS = [
  // --- Asia ---
  { code: "AF", label: "아프가니스탄 (Afghanistan)" },
  { code: "AM", label: "아르메니아 (Armenia)" },
  { code: "AZ", label: "아제르바이잔 (Azerbaijan)" },
  { code: "BH", label: "바레인 (Bahrain)" },
  { code: "BD", label: "방글라데시 (Bangladesh)" },
  { code: "BT", label: "부탄 (Bhutan)" },
  { code: "BN", label: "브루나이 (Brunei Darussalam)" },
  { code: "KH", label: "캄보디아 (Cambodia)" },
  { code: "CN", label: "중국 (China)" },
  { code: "GE", label: "조지아 (Georgia)" },
  { code: "HK", label: "홍콩 (Hong Kong)" },
  { code: "IN", label: "인도 (India)" },
  { code: "ID", label: "인도네시아 (Indonesia)" },
  { code: "IR", label: "이란 (Iran)" },
  { code: "IQ", label: "이라크 (Iraq)" },
  { code: "IL", label: "이스라엘 (Israel)" },
  { code: "JP", label: "일본 (Japan)" },
  { code: "JO", label: "요르단 (Jordan)" },
  { code: "KZ", label: "카자흐스탄 (Kazakhstan)" },
  { code: "KW", label: "쿠웨이트 (Kuwait)" },
  { code: "KG", label: "키르기스스탄 (Kyrgyzstan)" },
  { code: "LA", label: "라오스 (Laos)" },
  { code: "LB", label: "레바논 (Lebanon)" },
  { code: "MO", label: "마카오 (Macao)" },
  { code: "MY", label: "말레이시아 (Malaysia)" },
  { code: "MV", label: "몰디브 (Maldives)" },
  { code: "MN", label: "몽골 (Mongolia)" },
  { code: "MM", label: "미얀마 (Myanmar)" },
  { code: "NP", label: "네팔 (Nepal)" },
  { code: "KP", label: "북한 (Korea, DPR of)" },
  { code: "OM", label: "오만 (Oman)" },
  { code: "PK", label: "파키스탄 (Pakistan)" },
  { code: "PS", label: "팔레스타인 (Palestine, State of)" },
  { code: "PH", label: "필리핀 (Philippines)" },
  { code: "QA", label: "카타르 (Qatar)" },
  { code: "SA", label: "사우디아라비아 (Saudi Arabia)" },
  { code: "SG", label: "싱가포르 (Singapore)" },
  { code: "KR", label: "대한민국 (Korea, Republic of)" },
  { code: "LK", label: "스리랑카 (Sri Lanka)" },
  { code: "SY", label: "시리아 (Syrian Arab Republic)" },
  { code: "TW", label: "대만 (Taiwan)" },
  { code: "TJ", label: "타지키스탄 (Tajikistan)" },
  { code: "TH", label: "태국 (Thailand)" },
  { code: "TR", label: "튀르키예 (Türkiye)" },
  { code: "TM", label: "투르크메니스탄 (Turkmenistan)" },
  { code: "AE", label: "아랍에미리트 (United Arab Emirates)" },
  { code: "UZ", label: "우즈베키스탄 (Uzbekistan)" },
  { code: "VN", label: "베트남 (Vietnam)" },
  { code: "YE", label: "예멘 (Yemen)" },

  // --- Europe ---
  { code: "AL", label: "알바니아 (Albania)" },
  { code: "AD", label: "안도라 (Andorra)" },
  { code: "AT", label: "오스트리아 (Austria)" },
  { code: "BY", label: "벨라루스 (Belarus)" },
  { code: "BE", label: "벨기에 (Belgium)" },
  { code: "BA", label: "보스니아 헤르체고비나 (Bosnia and Herzegovina)" },
  { code: "BG", label: "불가리아 (Bulgaria)" },
  { code: "HR", label: "크로아티아 (Croatia)" },
  { code: "CY", label: "키프로스 (Cyprus)" },
  { code: "CZ", label: "체코 (Czech Republic)" },
  { code: "DK", label: "덴마크 (Denmark)" },
  { code: "EE", label: "에스토니아 (Estonia)" },
  { code: "FI", label: "핀란드 (Finland)" },
  { code: "FR", label: "프랑스 (France)" },
  { code: "DE", label: "독일 (Germany)" },
  { code: "GR", label: "그리스 (Greece)" },
  { code: "HU", label: "헝가리 (Hungary)" },
  { code: "IS", label: "아이슬란드 (Iceland)" },
  { code: "IE", label: "아일랜드 (Ireland)" },
  { code: "IT", label: "이탈리아 (Italy)" },
  { code: "LV", label: "라트비아 (Latvia)" },
  { code: "LI", label: "리히텐슈타인 (Liechtenstein)" },
  { code: "LT", label: "리투아니아 (Lithuania)" },
  { code: "LU", label: "룩셈부르크 (Luxembourg)" },
  { code: "MT", label: "몰타 (Malta)" },
  { code: "MD", label: "몰도바 (Moldova, Republic of)" },
  { code: "MC", label: "모나코 (Monaco)" },
  { code: "ME", label: "몬테네그로 (Montenegro)" },
  { code: "NL", label: "네덜란드 (Netherlands)" },
  { code: "MK", label: "북마케도니아 (North Macedonia)" },
  { code: "NO", label: "노르웨이 (Norway)" },
  { code: "PL", label: "폴란드 (Poland)" },
  { code: "PT", label: "포르투갈 (Portugal)" },
  { code: "RO", label: "루마니아 (Romania)" },
  { code: "RU", label: "러시아 (Russia)" },
  { code: "SM", label: "산마리노 (San Marino)" },
  { code: "RS", label: "세르비아 (Serbia)" },
  { code: "SK", label: "슬로바키아 (Slovakia)" },
  { code: "SI", label: "슬로베니아 (Slovenia)" },
  { code: "ES", label: "스페인 (Spain)" },
  { code: "SE", label: "스웨덴 (Sweden)" },
  { code: "CH", label: "스위스 (Switzerland)" },
  { code: "UA", label: "우크라이나 (Ukraine)" },
  { code: "GB", label: "영국 (United Kingdom)" },
  { code: "VA", label: "바티칸 (Vatican City)" },

  // --- Africa ---
  { code: "DZ", label: "알제리 (Algeria)" },
  { code: "AO", label: "앙골라 (Angola)" },
  { code: "BJ", label: "베냉 (Benin)" },
  { code: "BW", label: "보츠와나 (Botswana)" },
  { code: "BF", label: "부르키나파소 (Burkina Faso)" },
  { code: "BI", label: "부룬디 (Burundi)" },
  { code: "CM", label: "카메룬 (Cameroon)" },
  { code: "CV", label: "카보베르데 (Cabo Verde)" },
  { code: "CF", label: "중앙아프리카공화국 (Central African Republic)" },
  { code: "TD", label: "차드 (Chad)" },
  { code: "KM", label: "코모로 (Comoros)" },
  { code: "CD", label: "콩고민주공화국 (Congo, DRC)" },
  { code: "CG", label: "콩고공화국 (Congo, Republic of)" },
  { code: "CI", label: "코트디부아르 (Côte d'Ivoire)" },
  { code: "DJ", label: "지부티 (Djibouti)" },
  { code: "EG", label: "이집트 (Egypt)" },
  { code: "GQ", label: "적도기니 (Equatorial Guinea)" },
  { code: "ER", label: "에리트레아 (Eritrea)" },
  { code: "SZ", label: "에스와티니 (Eswatini)" },
  { code: "ET", label: "에티오피아 (Ethiopia)" },
  { code: "GA", label: "가봉 (Gabon)" },
  { code: "GM", label: "감비아 (Gambia)" },
  { code: "GH", label: "가나 (Ghana)" },
  { code: "GN", label: "기니 (Guinea)" },
  { code: "GW", label: "기니비사우 (Guinea-Bissau)" },
  { code: "KE", label: "케냐 (Kenya)" },
  { code: "LS", label: "레소토 (Lesotho)" },
  { code: "LR", label: "라이베리아 (Liberia)" },
  { code: "LY", label: "리비아 (Libya)" },
  { code: "MG", label: "마다가스카르 (Madagascar)" },
  { code: "MW", label: "말라위 (Malawi)" },
  { code: "ML", label: "말리 (Mali)" },
  { code: "MR", label: "모리타니 (Mauritania)" },
  { code: "MU", label: "모리셔스 (Mauritius)" },
  { code: "MA", label: "모로코 (Morocco)" },
  { code: "MZ", label: "모잠비크 (Mozambique)" },
  { code: "NA", label: "나미비아 (Namibia)" },
  { code: "NE", label: "니제르 (Niger)" },
  { code: "NG", label: "나이지리아 (Nigeria)" },
  { code: "RW", label: "르완다 (Rwanda)" },
  { code: "ST", label: "상투메 프린시페 (Sao Tome and Principe)" },
  { code: "SN", label: "세네갈 (Senegal)" },
  { code: "SC", label: "세이셸 (Seychelles)" },
  { code: "SL", label: "시에라리온 (Sierra Leone)" },
  { code: "SO", label: "소말리아 (Somalia)" },
  { code: "ZA", label: "남아프리카공화국 (South Africa)" },
  { code: "SS", label: "남수단 (South Sudan)" },
  { code: "SD", label: "수단 (Sudan)" },
  { code: "TZ", label: "탄자니아 (Tanzania)" },
  { code: "TG", label: "토고 (Togo)" },
  { code: "TN", label: "튀니지 (Tunisia)" },
  { code: "UG", label: "우간다 (Uganda)" },
  { code: "ZM", label: "잠비아 (Zambia)" },
  { code: "ZW", label: "짐바브웨 (Zimbabwe)" },

  // --- North America ---
  { code: "AG", label: "앤티가 바부다 (Antigua and Barbuda)" },
  { code: "BS", label: "바하마 (Bahamas)" },
  { code: "BB", label: "바베이도스 (Barbados)" },
  { code: "BZ", label: "벨리즈 (Belize)" },
  { code: "CA", label: "캐나다 (Canada)" },
  { code: "CR", label: "코스타리카 (Costa Rica)" },
  { code: "CU", label: "쿠바 (Cuba)" },
  { code: "DM", label: "도미니카 연방 (Dominica)" },
  { code: "DO", label: "도미니카 공화국 (Dominican Republic)" },
  { code: "SV", label: "엘살바도르 (El Salvador)" },
  { code: "GD", label: "그레나다 (Grenada)" },
  { code: "GT", label: "과테말라 (Guatemala)" },
  { code: "HT", label: "아이티 (Haiti)" },
  { code: "HN", label: "온두라스 (Honduras)" },
  { code: "JM", label: "자메이카 (Jamaica)" },
  { code: "MX", label: "멕시코 (Mexico)" },
  { code: "NI", label: "니카라과 (Nicaragua)" },
  { code: "PA", label: "파나마 (Panama)" },
  { code: "KN", label: "세인트키츠 네비스 (Saint Kitts and Nevis)" },
  { code: "LC", label: "세인트루시아 (Saint Lucia)" },
  {
    code: "VC",
    label: "세인트빈센트그레나딘 (Saint Vincent and the Grenadines)",
  },
  { code: "TT", label: "트리니다드토바고 (Trinidad and Tobago)" },
  { code: "US", label: "미국 (United States)" },

  // --- South America ---
  { code: "AR", label: "아르헨티나 (Argentina)" },
  { code: "BO", label: "볼리비아 (Bolivia)" },
  { code: "BR", label: "브라질 (Brazil)" },
  { code: "CL", label: "칠레 (Chile)" },
  { code: "CO", label: "콜롬비아 (Colombia)" },
  { code: "EC", label: "에콰도르 (Ecuador)" },
  { code: "GY", label: "가이아나 (Guyana)" },
  { code: "PY", label: "파라과이 (Paraguay)" },
  { code: "PE", label: "페루 (Peru)" },
  { code: "SR", label: "수리남 (Suriname)" },
  { code: "UY", label: "우루과이 (Uruguay)" },
  { code: "VE", label: "베네수엘라 (Venezuela)" },

  // --- Oceania ---
  { code: "AU", label: "호주 (Australia)" },
  { code: "FJ", label: "피지 (Fiji)" },
  { code: "KI", label: "키리바시 (Kiribati)" },
  { code: "MH", label: "마셜제도 (Marshall Islands)" },
  { code: "FM", label: "미크로네시아 (Micronesia)" },
  { code: "NR", label: "나우루 (Nauru)" },
  { code: "NZ", label: "뉴질랜드 (New Zealand)" },
  { code: "PW", label: "팔라우 (Palau)" },
  { code: "PG", label: "파푸아뉴기니 (Papua New Guinea)" },
  { code: "WS", label: "사모아 (Samoa)" },
  { code: "SB", label: "솔로몬제도 (Solomon Islands)" },
  { code: "TO", label: "통가 (Tonga)" },
  { code: "TV", label: "투발루 (Tuvalu)" },
  { code: "VU", label: "바누아투 (Vanuatu)" },

  // --- 마지막: 기타 ---
  { code: "OTHER", label: "기타 (Other)" },
];
